//-----------------------------
// clear local combatant ranks
//-----------------------------
export default function clearLocalCombatantRanks(combatants) {
  // console.log("------------------------")
  // console.log("IN clearLocalCombatantRanks")
  combatants.forEach((c) => {
    c.dupe_rank = false;
    c.dupe_processed = false;
    c.is_ranked = false;
    c.sr_roll = 0;
    c.roll_off = 0;
    c.rank = 0;
  });
  return combatants;
}
